import run from '../../utilities/run';
import $ from 'jquery';
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import {handleDisplayFor, resetDisplay, hide, setElementsFromScope, setOptionsForSelect} from "../../utilities/selectorHelpers";
import {anyChecked} from './utilities';
const _ = require("underscore");
import timePicker from "../../components/timePicker/timePicker";

export default function EbayConfigurationsTab(wizard){

  const self = this;
  const el = wizard.getWizardElement();
  const retpartner=el.data("retailer-partners-info");
  const orderProcessingTogglers = el.find("#ebayOrderProcessingCheck");
  const orderProcessingIcon=el.find("#ebayOrderProcessingCheck");
  let orderProcessingIconStatus=false;
  let dateTime="";
  let beginOrderProcessingFrom="";
  let startDateValue=el.data("start-date-value");
  let timePickerHoursSelectValue=el.data( "time-picker-hours-select-value");
  let timePickerMinSelectValue=el.data("time-picker-minutes-select-value");
  let timePickerPeriodSelectValue=el.data("time-picker-period-select-value");
  const orderProcessingDateTimeSelect = el.find("#orderProcessingDateTimeOptions");
  let orderProcessingDateTimeSelectList = orderProcessingDateTimeSelect.data('options');
  const dateTimePickerSection=el.find("#order-processing-date-time-picker");
  const startDate=el.find(".start-date");
  const timePickerHoursSelect=el.find(".time-picker-hours-select");
  const timePickerMinSelect=el.find(".time-picker-minutes-select");
  const timePickerPeriodSelect=el.find(".time-picker-period-select");
  const timePickerTarget = el.find('.time-picker');
  timePicker(timePickerTarget);

  self.init = function(){
      onLoad();
    };

  self.didNavigateToForm = function(){

    };

  function onLoad(){
     loadConfiguration(retpartner);
  }

  function loadConfiguration(data){
    loadOrderProcessingConfiguration(data);
    toggleOrderProcessingDateTime(orderProcessingIcon, data.repOrdersProcessingFlag);
  }

  function loadOrderProcessingConfiguration(data){
    if(data.repOrdersProcessingFlag){
      $("#ebayOrderProcessingCheck").val(true);
      $("#ebayOrderProcessingCheck").prop('checked', true);
    }else{
      $("#ebayOrderProcessingCheck").val(false);
      $("#ebayOrderProcessingCheck").prop('checked', false);
    }
    beginOrderProcessingFrom=data.repPullOrdersUri;
    orderProcessingDateTimeSelect.val(beginOrderProcessingFrom);
    orderProcessingDateTimeSelect.trigger('change');
  }

  toggleOrderProcessingDateTime();

  orderProcessingTogglers.on("change", function(e) {
    toggleOrderProcessingDateTime(this.id, this.value);
  });

  function toggleOrderProcessingDateTime(toggleSwitchId, toggleSwitchValue) {
    let isOn=anyChecked(orderProcessingIcon);

    dateTimePickerSection.hide();
    if (isOn) {
      dateTimePickerSection.show();
      orderProcessingDateTimeSelect.change();
      $("#ebayOrderProcessingCheck").val(true);
      $("#ebayOrderProcessingCheck").prop('checked', true);
    } else {
      dateTimePickerSection.hide();
      orderProcessingSelectChanged(null,null);
      orderProcessingDateTimeSelect.val("");
      $("#ebayOrderProcessingCheck").val(false);
      $("#ebayOrderProcessingCheck").prop('checked', false);
    }

  }

  setOptionsForSelect({
    selectElement: orderProcessingDateTimeSelect,
    list: orderProcessingDateTimeSelectList,
    valueDataKey: "cdmValue",
    textDataKey: "cdmDescription"
  });

  orderProcessingDateTimeSelect.on('change', function(){
    orderProcessingSelectChanged(this.value, this.text);
  });

  function orderProcessingSelectChanged(val, text){
    if(val==="future" || val==="past"){
      dateTimePickerSection.show();
      setCalendarProperties(val);

      if(startDateValue===null || startDateValue===""){
        setDateTimePeriodDefaultValue();
      }else{
        startDate.val(startDateValue);
        timePickerHoursSelect.val(timePickerHoursSelectValue);
        timePickerHoursSelect.change();
        timePickerMinSelect.val(timePickerMinSelectValue);
        timePickerMinSelect.change();
        timePickerPeriodSelect.val(timePickerPeriodSelectValue);
        timePickerPeriodSelect.change();
      }

    }else{
      dateTimePickerSection.hide();
      startDate.val("");
      timePickerHoursSelect.change();
      timePickerMinSelect.change();
      timePickerPeriodSelect.change();
    }
  }

  function setDateTimePeriodDefaultValue(){
   timePickerHoursSelect.val("1");
   timePickerMinSelect.val("00");
   timePickerPeriodSelect.val("AM");
  }

  function setCalendarProperties(selectedDropdownValue){
   const date = new Date();
   if(selectedDropdownValue==="future"){
       $(".func-date-range-input").datepicker({
       minDate: date,
       todayBtn: "linked",
       keyboardNavigation: false,
       autoclose: true
     });
   }else if(selectedDropdownValue==="past"){
     $(".func-date-range-input").datepicker({
       maxDate: date,
       todayBtn: "linked",
       keyboardNavigation: false,
       autoclose: true
   });

  }
 }
}



// WEBPACK FOOTER //
// ./src/pages/createChannel/ebayConfigurationsTab.js